import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";
import { ContactSupportOutlined } from "@material-ui/icons";

function* customerListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.CUSTOMERS_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.customerList_Success(response.data));
    } else {
      yield put(ACTION.customerList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.customerList_Fail(response.data.error));
  }
}
function* EditUsersaga({ payload, callBack }) {
  try {
    const response = yield call(API.EDIT_MANAGE_CUSTOMER, payload);
    if (response.status == 200) {
      yield put(ACTION.editCustomer_Success(response.data));
    } else {
      yield put(ACTION.editCustomer_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.editCustomer_Fail(response.data.error));
  }
}
function* updateUserSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_USER, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateUser_Success(response.data));
    } else {
      toast.error(response.data.detail);
      yield put(ACTION.updateUser_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateUser_Fail(response.data.error));
  }
}
function* addUserSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_USER, payload);
    console.log(response, "responsee");
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addUser_Success(response.data));
    } else {
      console.log("innner else");
      toast.error(response.data.detail || response.data.error);
      yield put(ACTION.addUser_Fail(response.data.error));
    }
  } catch (error) {
    console.log("catch error");
    yield put(ACTION.addUser_Fail(response.data.error));
  }
}
function* blockUnblockUserSaga({ payload, callBack }) {
  try {
    const response = yield call(API.BLOCK_UNBLOCK_USER, payload);

    if (response.data.status == 200) {
      yield put(ACTION.blockUnblockUser_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.blockUnblockUser_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.blockUnblockUser_Fail(response.data.error));
  }
}
function* deleteUserSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_USER, payload);
    if (response.data.status == 200) {
      yield put(ACTION.deleteUser_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.deleteUser_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteUser_Fail(response.data.error));
  }
}

function* sendEmailSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SEND_EMAIL, payload);
    callBack && callBack(response.data);
    if (response.data.detail) {
      yield put(ACTION.sendEmail_Success(response.data));
    } else {
      yield put(ACTION.sendEmail_Fail(response.data.error));
      toast.error(response.data.error);
    }
  } catch (error) {
    yield put(ACTION.sendEmail_Fail(response.data.error));
  }
}

function* sendTextSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SEND_TEXT, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.sendText_Success(response.data));
    } else {
      yield put(ACTION.sendText_Fail(response.data.error));
      toast.error(response.data.error);
    }
  } catch (error) {
    yield put(ACTION.sendText_Fail(response.data.error));
  }
}

function* postDocumentFileSaga({ payload, callBack }) {
  try {
    const response = yield call(API.POST_DOCUMENT_FILE, payload);
    if (response.data.status == 200) {
      yield put(ACTION.postDocumentFile_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.postDocumentFile_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.postDocumentFile_Fail(response.data.error));
  }
}

function* deleteUserDocumentSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_USER_DOCUMENT, payload);

    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteUserDocument_Success(response.data));
    } else {
      yield put(ACTION.deleteUserDocument_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteUserDocument_Fail(response.data.error));
  }
}

function* updateDocumentFileSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_DOCUMENT_FILE, payload);
    if (response.data.status == 200) {
      yield put(ACTION.updateDocumentFile_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.updateDocumentFile_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateDocumentFile_Fail(response.data.error));
  }
}

function* getDocumentFileSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_DOCUMENT_FILE, payload);
    if (response.data.status == 200) {
      yield put(ACTION.getDocumentFile_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.getDocumentFile_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getDocumentFile_Fail(response.data.error));
  }
}

function* acceptRejectSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ACCEPT_REJECT_DOCUMENT, payload);
    if (response.data.status == 200) {
      yield put(ACTION.acceptRejectDocument_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.acceptRejectDocument_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.acceptRejectDocument_Fail(response.data.error));
  }
}

function* sendDocumentListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SEND_DOCUMENTS_LIST, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.sendDocumentList_Success(response.data));
    } else {
      yield put(ACTION.sendDocumentList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.sendDocumentList_Fail(response.data.error));
  }
}

function* resetUserPassSaga({ payload, callBack }) {
  try {
    const response = yield call(API.RESET_USER_PASS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.resetUserPass_Success(response.data));
    } else {
      yield put(ACTION.resetUserPass_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.resetUserPass_Fail(response.data.error));
  }
}

function* addNoteSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_NOTE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addNote_Success(response.data));
    } else {
      yield put(ACTION.addNote_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addNote_Fail(response.data.error));
  }
}

function* getNoteByidSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_NOTE_BY_ID, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getNoteById_Success(response.data));
    } else {
      yield put(ACTION.getNoteById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getNoteById_Fail(response.data.error));
  }
}

function* updateNoteSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_NOTE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateNote_Success(response.data));
    } else {
      yield put(ACTION.updateNote_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateNote_Fail(response.data.error));
  }
}

function* singleNoteSaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_SINGLE_NOTE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.getSingleNote_Success(response.data));
    } else {
      yield put(ACTION.getSingleNote_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getSingleNote_Fail(response.data.error));
  }
}

function* deleteNoteSaga({ payload, callBack }) {
  console.log(payload, "delete note payload");
  try {
    const response = yield call(API.DELETE_NOTE, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteNote_Success(response.data));
    } else {
      yield put(ACTION.deleteNote_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteNote_Fail(response.data.error));
  }
}

function* smsHistorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.SMS_HISTORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.smsHistory_Success(response.data));
    } else {
      yield put(ACTION.smsHistory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.smsHistory_Fail(response.data.error));
  }
}

function* addEmailDraftSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_EMAIL_DRAFT, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addEmailDraft_Success(response.data));
    } else {
      yield put(ACTION.addEmailDraft_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addEmailDraft_Fail(response.data.error));
  }
}

function* draftEmailListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DRAFT_EMAIL_LIST, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.draftEmailList_Success(response.data));
    } else {
      yield put(ACTION.draftEmailList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.draftEmailList_Fail(response.data.error));
  }
}

function* draftEmailByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DRAFT_EMAIL_BY_ID, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.draftEmailById_Success(response.data));
    } else {
      yield put(ACTION.draftEmailById_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.draftEmailById_Fail(response.data.error));
  }
}

function* UserSaga() {
  yield takeEvery(CONST.CUSTOMERS_LIST, customerListSaga);
  yield takeEvery(CONST.EDIT_CUSTOMER, EditUsersaga);
  yield takeEvery(CONST.UPDATE_USER, updateUserSaga);
  yield takeEvery(CONST.ADD_USER, addUserSaga);
  yield takeEvery(CONST.BLOCK_UNBLOCK_USER, blockUnblockUserSaga);
  yield takeEvery(CONST.DELETE_USER, deleteUserSaga);
  yield takeEvery(CONST.SEND_EMAIL, sendEmailSaga);
  yield takeEvery(CONST.SEND_TEXT, sendTextSaga);
  yield takeEvery(CONST.POST_DOCUMENT_FILE, postDocumentFileSaga);
  yield takeEvery(CONST.UPDATE_DOCUMENT_FILE, updateDocumentFileSaga);
  yield takeEvery(CONST.GET_DOCUMENT_FILE, getDocumentFileSaga);
  yield takeEvery(CONST.ACCEPT_REJECT_DOCUMENT, acceptRejectSaga);
  yield takeEvery(CONST.SEND_DOCUMENTS_LIST, sendDocumentListSaga);
  yield takeEvery(CONST.RESET_USER_PASS, resetUserPassSaga);
  yield takeEvery(CONST.DELETE_USER_DOCUMENT, deleteUserDocumentSaga);
  yield takeEvery(CONST.ADD_NOTE, addNoteSaga);
  yield takeEvery(CONST.GET_NOTE_BY_ID, getNoteByidSaga);
  yield takeEvery(CONST.UPDATE_NOTE, updateNoteSaga);
  yield takeEvery(CONST.GET_SINGLE_NOTE, singleNoteSaga);
  yield takeEvery(CONST.DELETE_NOTE, deleteNoteSaga);
  yield takeEvery(CONST.SMS_HISTORY, smsHistorySaga);
  yield takeEvery(CONST.ADD_EMAIL_DRAFT, addEmailDraftSaga);
  yield takeEvery(CONST.DRAFT_EMAIL_LIST, draftEmailListSaga);
  yield takeEvery(CONST.DRAFT_EMAIL_BY_ID, draftEmailByIdSaga);
}

export default UserSaga;
